import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ComingSoonPageComponent } from "./coming-soon/coming-soon-page.component";
import { ConnectToLearnComponent } from './connect-to-learn/connect-to-learn.component';
import { ErrorPageComponent } from "./error/error-page.component";
import { ForgotPasswordPageComponent } from "./forgot-password/forgot-password-page.component";
import { LandingNewComponent } from './landing-new/landing-new.component';
import { LockScreenPageComponent } from "./lock-screen/lock-screen-page.component";
import { LoginPageComponent } from "./login/login-page.component";
import { MaintenancePageComponent } from "./maintenance/maintenance-page.component";
import { ThanksPageComponent } from './thanks-page/thanks-page.component';
import { LmsContentShowComponent } from './lms-content-show/lms-content-show.component';
import { LoginGuard } from 'app/shared/auth/auth-guard.service';
import { TaskViewComponent } from './task-view/task-view.component';
import { CollegeReportDetailsComponent } from './college-report-details/college-report-details.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'comingsoon',
        component: ComingSoonPageComponent,
       
      },
      {
        path: 'error',
        component: ErrorPageComponent,
        data: {
          title: 'Error Page'
        }
      },
      {
        path: 'forgotpassword',
        component: ForgotPasswordPageComponent,
        
      },

      {
        path: 'lockscreen',
        component: LockScreenPageComponent,
       
      },
      {
        path: 'login',
        component: LoginPageComponent,
        data: {
          title: 'Login Page'
        }
      },
      {
        path: 'maintenance',
        component: MaintenancePageComponent,
        data: {
          title: 'Maintenance Page'
        }
      },
      {
        path: 'connect-to-learn',
        component: ConnectToLearnComponent,
        // component: RegisterPageComponent,
        data: {
          title: 'Connect to learn'
        }
      },
      {
        path: 'get-placed',
        component: ConnectToLearnComponent,
        // component: RegisterPageComponent,
        data: {
          title: 'Register Page'
        }
      },
      {
        path: 'thanks-for-register',
        component: ThanksPageComponent,
       
      },

      {
        path: 'landing',
        component: LandingNewComponent,
        
      }

    ], canActivate: [LoginGuard]
  },
  {
    path: 'lms-content/:id',
    component: LmsContentShowComponent,
    data: {
      title: 'LMS Content'
    }
  },
  {
    path: 'research-base',
    loadChildren: () => import('../full-pages/admin/meander-rb/meander-rb.module').then(m => m.MeanderRbModule)
  },
  {
    path: 'digital-assets/:id',
    component: LmsContentShowComponent,
    data: {
      title: 'Digital Assets'
    }
  } ,
  {
    path: 'task-view/:id',
    component: TaskViewComponent,
    data: {
      title: 'Task Details'
    }
  },  
  {
    path: 'candidate-view/:id',
    component: TaskViewComponent,
    data: {
      title: 'Candidate View'
    }
  },  
  {
    path:'college-reports-details/:id',component:CollegeReportDetailsComponent,
    data: {
      title: 'College Reports Detail'
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContentPagesRoutingModule { }
